import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import GS from "@ts/GlobalSetting";

import {gsap} from "gsap";
import { Product } from "./ProductTypes";
import ApiProxy from "@root/ts/ApiProxy";
import EZAlert from "../popups/EZAlert";
import Tools from "@root/ts/Tools";
import TextBubble from "../ui/TextBubble";
import Utility from "../../ts/sframe/Utility";
import Sharer from "../../ts/Sharer";

export default class ProductPromote extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);

    let pageData: Product.PageData = ApiProxy.getPageData(),
      promoteData = pageData.promote_data;

    let $detail = this.$root.find(".detail"),
      $features = this.$root.find(".features");

    if(promoteData.promote_price)
    {
      this.$root.attr("with-promote", "true");

      this.$root.find(".price-1 .num").text(Tools.formatNumber(promoteData.promote_price));
      this.$root.find(".price-2 .num").text(Tools.formatNumber(promoteData.price));
    }
    else
    {
      this.$root.attr("with-promote", "false");
      this.$root.find(".price-1 .num").text(Tools.formatNumber(promoteData.price));
    }

    $features.find(".li-location").text(`地點：${promoteData.features.location}`);
    $features.find(".li-refund").text(`${promoteData.features.refund}天前可免費取消`);
    $features.find(".li-duration").text(`行程時間：${promoteData.features.duration}`);

    if(promoteData.brief)
    {
      let data = promoteData.brief;
  
      $detail.find(`.name`).attr("href", data.url).text(data.name);
      $detail.find(`.detail`).text(data.detail);
      $detail.find(`.date`).text(data.duration);

      $detail.find(".help").on("click", (event:JQuery.ClickEvent)=>
      {
        event.preventDefault();

        EZAlert.alert("活動說明", data.help_text);
      });
    }
    else
    {
      $detail.css("display", "none");
    }
    
    this.$root.find(".btn-go").on("click", function(event:Event)
    {
      event.preventDefault();
      
      let target = this.getAttribute("href"),
      offsetY = GS.getNavHeight();
      
      gsap.to(window, {duration: .5, scrollTo: {y: target, offsetY: offsetY}});
    });

    this._setupSocialButtons();
  }

  private _setupSocialButtons()
  {
    let $btnShareLink = this.$root.find(`[data-icon="social-icon-share-black"]`),
      $btnShareLine = this.$root.find(`[data-icon="social-icon-line-black"]`),
      $btnShareFacebook = this.$root.find(`[data-icon="social-icon-fb-black"]`);

    $btnShareLink.on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      // navigator.clipboard.writeText(Utility.copyTextToClipboard);

      Utility.copyTextToClipboard(window.location.href, ()=>
      {
        TextBubble.instance.popupAt($btnShareLink[0], `產品連結已複製到剪貼簿`);
      });
    });

    $btnShareLine.on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      Sharer.toLine();
    });

    $btnShareFacebook.on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      Sharer.toFacebook();
    });
    
  }
}